module.exports = __webpack_public_path__ + "static/img/img.99c964e7.png";